import { SerializedNode } from '@craftjs/core';

import i18next from 'i18next';
import { FormFieldWithOptionsProps } from '../builder/types/BaseControlTypes';
import { IControlsResolver } from '../builder/types/IControlsResolver';

const throwNotImplemented = () => {
  throw new Error('Not implemented yet');
};

const getOptionWeight = (node: SerializedNode, answer: number | string): number | undefined => {
  const props = node.props as FormFieldWithOptionsProps;
  if (props.options.some((x) => x.scoreWeight === undefined))
    throw new Error(
      i18next.t('GeneralFormBuilder.Panels.Score.ExpressionModal.Errors.NoOptionWeight', {
        datakey: node.props.dataKey,
      }),
    );

  return props.options.find((o) => o.key === answer)?.scoreWeight;
};

const getOptionWeightVm = (node: SerializedNode, answer: any): (number | undefined)[] | undefined => {
  if (answer === undefined || answer === null) return answer;

  const props = node.props as FormFieldWithOptionsProps;
  if (!Array.isArray(answer)) throw new Error('Answer is not Array');

  if (props.options.some((x) => x.scoreWeight === undefined))
    throw new Error(
      i18next.t('GeneralFormBuilder.Panels.Score.ExpressionModal.Errors.NoOptionWeight', {
        datakey: node.props.dataKey,
      }),
    );

  return props.options.filter((x) => answer.includes(x.key)).map((x) => x.scoreWeight);
};

const getDirectValue = (node: SerializedNode, answer: any): number | undefined => {
  if (answer === undefined || answer === null) return answer;

  if (isNaN(+answer)) throw new Error('Answer is not a number');

  return Number(answer);
};

const getNanValue = (node: SerializedNode, answer: any) => answer;

export const CalculatorControlsResolver: {
  [key: keyof IControlsResolver]: (node: SerializedNode, answer: any) => any;
} = {
  // Inputs
  FormTextInput: getNanValue,
  FormMultipleTextInput: getNanValue,
  FormDateInput: getNanValue,
  FormDateRangeInput: getNanValue,
  FormTagInput: getNanValue,
  FormFileInput: throwNotImplemented,
  FormMultipleDropdownInput: getOptionWeightVm,
  FormCheckboxGroupInput: getOptionWeightVm,
  FormNumberInput: getDirectValue,
  FormTimeInput: getDirectValue,
  FormRadioGroupInput: getOptionWeight,
  FormDropdownInput: getOptionWeight,
  FormSliderInput: getDirectValue,
};
